import type { IResponse } from '@/features/api/extranet'
import type { VirementDTO } from '@/features/api/extranet/dto/Virement'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export async function loadVirement(code: string, init?: RequestInit): Promise<VirementDTO> {
  init = ({
	sablier: true,
	dialogMode: 'retry',
	...init
})

  const fetch = useFetch('extranet')
  const response = await fetch(`/virements/${code}`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<VirementDTO>

  return result.data
}

